import { PenlikeShape2 } from "./PenShape";
import { ShapeDOMRepresentation } from "../types/ShapeDOMRepresentation";
import Camera from "../Camera";
import { Shape2 } from "../types/Shape";
import CanvasBasedDOMRepresentation from "@/wbcontroller/CanvasBasedDOMRepresentation";
import { PenShapeRenderer } from "./PenShapeRenderer";

/**
 * Can render PenShape objects to DOM.
 */
export class PenShapeDOMRepresentation
  extends CanvasBasedDOMRepresentation
  implements ShapeDOMRepresentation
{
  renderer: PenShapeRenderer;

  penShape: PenlikeShape2;

  constructor(
    id: string,
    shape: PenlikeShape2,
    transformEl: HTMLElement,
    camera: Camera
  ) {
    super(id, shape, transformEl, camera);
    this.penShape = shape;
    this.renderer = new PenShapeRenderer(shape, id);
    this.redraw();
  }

  get strokeStyle(): string {
    return this.penShape.strokeColor;
  }

  get dotFillStyle(): string {
    return this.strokeStyle;
  }

  get maySelect(): boolean {
    // Disallow selection of shapes being drawn
    return !this.penShape.isOpen;
  }

  // get selectionRectInset(): Vector {
  //   return new Vector(this.penShape.width, this.penShape.width);
  // }

  update(newShape: Shape2, isLive = true) {
    this.penShape = newShape as PenlikeShape2;
    this.shape = this.penShape;
    if (isLive) {
      this.renderer.update(this.penShape);
      this.prepareCanvasForDrawing(this.getBackingScale(), this.canvas, true);
      this.redraw();
    }
  }

  getShouldClear(): boolean {
    return !this.penShape.isOpen;
  }

  drawShape(ctx: CanvasRenderingContext2D) {
    ctx.lineCap = "round";
    ctx.strokeStyle = this.strokeStyle;
    ctx.lineWidth = this.penShape.strokeWidth;
    this.renderer.drawShape(ctx);
  }
}

export class EraserShapeDOMRepresentation extends PenShapeDOMRepresentation {
  get strokeStyle(): string {
    return "white";
  }

  get maySelect(): boolean {
    return false;
  }
}
